import Route from '@ember/routing/route';

export default class MessagesRoute extends Route {
  model() {
    return null;
  }
}
